import { render, staticRenderFns } from "./TipsToast.vue?vue&type=template&id=45e188b6&"
import script from "./TipsToast.vue?vue&type=script&lang=ts&"
export * from "./TipsToast.vue?vue&type=script&lang=ts&"
import style0 from "./TipsToast.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports